// tooling to be able to verify whether we still have async turbo stuff loading
window.turbo_count = 0;

document.addEventListener("turbo:visit", function () {
  window.turbo_count += 1;

  console.log(`turbo:visit | ${window.turbo_count} remaining turbo events`);
});

document.addEventListener("turbo:load", function () {
  // initial page load also triggers turbo:load
  if (window.turbo_count > 0) window.turbo_count -= 1;

  console.log(`turbo:load | ${window.turbo_count} remaining turbo events`);
});

// compatibility layer for older turbolinks events
//
// activeadmin is nog niet klaar voor Turbo 6 en verwacht de oude events
// om UI te activeren (vb batch action knop)
document.addEventListener("turbo:click", function () {
  document.dispatchEvent(new CustomEvent("turbolinks:click"));
});

document.addEventListener("turbo:load", function () {
  document.dispatchEvent(new CustomEvent("turbolinks:load"));
});
